import { useEffect } from 'react';
import {
  DocumentsParams,
  OperatorDocumentTableList,
} from 'src/apis/document-exchange/types';
import { useAxios } from 'src/hooks/use-axios';
import urlTemplate from 'url-template';

type HookConfig = {
  url: string;
  params?: DocumentsParams;
};

type RequestOptions = {
  params?: DocumentsParams;
};

export function useOperatorDocumentsOutbox({ url, params }: HookConfig) {
  const documents = useAxios(
    (axios, signal, { params }: RequestOptions) =>
      axios.request<OperatorDocumentTableList>({
        signal,
        method: 'GET',
        url: urlTemplate.parse(url).expand({}),
        params,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    const options = { params };
    documents.execute(options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return documents;
}

export type OperatorDocumentsOutboxRequest = ReturnType<
  typeof useOperatorDocumentsOutbox
>;
